import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { DamserviceService } from "../dam/damservice.service";
import { environment } from '../../environments/environment';
import { SubscriptionService } from "../subscription/subscription.service";
import { AuthService } from "angularx-social-login";
import { AlertService } from "../components/alert/alert.service";
import { WindowRefService } from '../services/window-ref.service';
import { OrganisationService } from "../create-organisation/organisation.service";
import { FormBuilder, Validators } from '@angular/forms';
import { GoogleLoginProvider } from "angularx-social-login";
import AOS from 'aos';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  title = 'Checkout | Workspace | Crafttor';

  math = Math;

  customCheckoutSection: boolean = false;
  showLoginPage: boolean = false;
  showNotPageExist: boolean = false;
  socialLoginSection: boolean = false;
  tellUsMoreSection: boolean = false;
  createWorkspaceSection: boolean = false;
  paymentSuccessSection: boolean = false;

  radioYearly: boolean = true;
  detailsYearly: boolean = true;
  radioMonthly: boolean = false;

  checkoutToken: any;
  currentUser: User;
  strikeCheckout: any = null;
  totalPriceFixed: any;
  addUserCount: any;
  isCustomPlan: boolean = true;

  address: string = '128 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';

  finalPrice: any;
  totalWorkspace: any;
  totalSeats: any;
  totalAdmin: any;
  totalStorageSpace: any;

  totalRazorAmount: any;
  userRazorPayName: string;
  razorPayKey: string;
  orderId: any;
  couponcode: any;

  showTopRightLoader: boolean = false;
  sendSuccessfulMsg: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  successfullMessage: string;
  sendSuccessfulErrorMessage: string;

  isShowCreateWorkspaceError: boolean = false;
  createWorkspaceErrorMessage: any;
  createWorkspaceLoginErrorMessage: string;

  login: boolean = true;
  emailVerify: boolean = false;
  signup: boolean = false;
  forgotpassword: boolean = false;
  forgotpasswordFields: boolean = false;
  enterOtp: boolean = false;
  resetPassword: boolean = false;

  submitted: Boolean = false;
  submitt: Boolean = false;
  submittedForm: Boolean = false;
  submittion: Boolean = false;
  emailVerifySubmit: Boolean = false;
  passwordSubmit: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;
  workspace_token: string;
  emailId: string;
  emailIds: string;
  forgotPasswordErrorMsg: string;
  loginErrorMsg: string;
  selectRoleTitle: string = "Founder";
  showSending: boolean = false;
  showSendingSmall: boolean = false;
  showTellUsLoader: boolean = false;
  tellUsMoreSectionErrorMsg: any;
  showTellUsMoreSectionError: boolean = false;
  signUpFormFilled: boolean = false;
  fromScreen: any;
  screenToken: any;
  showLeaveLoader: boolean = false;
  showGoogleLoginLoader: boolean = false;

  public lat;
  public lng;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  loginForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    password: ['', Validators.required],
  });

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  enterOtpForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  emailVerifyForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  signUpForm = this.fb.group({
    fname: ['', Validators.required],
    lname: ['', Validators.required],
    password: ['', Validators.required],
    otp: ['', Validators.required],
  });

  resetPasswordForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  enterNewDetails = this.fb.group({
    organization: [''],
    phoneNumber: [''],
    roleTitle: [''],
  });


  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private titleService: Title,
    private metaTagService: Meta,
    private authenticationService: AuthenticationService,
    private damService: DamserviceService,
    private subscriptionService: SubscriptionService,
    private authService: AuthService,
    private alert: AlertService,
    private winRef: WindowRefService,
    private organisationService: OrganisationService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor digital assets management is a trendy and awesome file manager. You can store, organise and tag your assets in an attractive manner. Hurry up, sign up today!'},
      { name: 'keywords', content: 'login. workspace, login crafttor, login digital assets managment, digital assets management, dam, DAM' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    if(this.paymentSuccessSection == true) {
      this.showLeaveLoader = false;
      this.tellUsMoreSection = false;
      this.signUpFormFilled = false;
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = false;
      this.paymentSuccessSection = true;
      this.customCheckoutSection = false;
    }

    this.authService.authState.subscribe((user) => {
      if (user && !this.authenticationService.currentUserValue) {
        this.loginToServer(user, user.photoUrl, this.workspace_token);
      }
    });

    this.activateRoute.queryParams.subscribe(params => {
      this.checkoutToken = params['token'];
    });

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });

    if(this.currentUser) {
      this.showLoginPage = false;
      this.getCustomPaymentData();
      this.getLocation();
    } else {
      this.openLoginModal();
      // localStorage.setItem('loginPaymentDetails', JSON.stringify({
      //   fromScreen: "payment-screen", screenToken: this.checkoutToken}));
      // this.router.navigate(['/login']);
    }

    var getTokenDetails = JSON.parse(localStorage.getItem('loginPaymentDetails'));
    this.checkoutToken = getTokenDetails.screenToken;
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  startForFree(){
    if (this.currentUser) {
      this.router.navigate(['/dam']);
    }else{
      this.router.navigate(['/login']);
    }
  }

  clickToLogin() {
    this.router.navigate(['/login']);
  }

  showMainSection() {
    this.router.navigate(['/dam']);
  }

  chooseMonthly(){
    this.radioYearly=false;
    this.radioMonthly=true;
  }

  chooseYearly(){
    this.radioMonthly=false;
    this.radioYearly=true;
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  getCustomPaymentData() {
    this.showTopRightLoader = true;
    this.damService.getCustomPaymentData(this.checkoutToken).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.customCheckoutSection = true;
      this.paymentSuccessSection = false;
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = false;
      this.finalPrice = data.amount;
      this.totalWorkspace = data.allowed_workspace_count;
      this.totalSeats = data.allowed_seats;
      this.totalAdmin = data.allowed_admin_count;
      this.totalStorageSpace = data.space;
    },(error: any) => {
      if(error.status == 400){
        this.titleService.setTitle("Link expired or page does not exist");
        this.showTopRightLoader = false;
        this.customCheckoutSection = false;
        this.paymentSuccessSection = false;
        this.showNotPageExist = true;
        this.showLoginPage = false;
        this.showTopRightLoader = false;
        this.tellUsMoreSection = false;
        this.createWorkspaceSection = false;
        this.socialLoginSection = false;
      } else {
        this.titleService.setTitle("Link expired or page does not exist");
        this.showTopRightLoader = false;
        this.paymentSuccessSection = false;
        this.customCheckoutSection = false;
        this.showNotPageExist = true;
        this.showLoginPage = false;
        this.showTopRightLoader = false;
        this.tellUsMoreSection = false;
        this.createWorkspaceSection = false;
        this.socialLoginSection = false;
      }
   });
  }

  checkoutStripe() {
    const strikeCheckout = (<any>window).StripeCheckout.configure({
      key: environment.STRIPE_LIVE_KEY,
      locale: 'auto',
      token: (stripeToken: any) => {
        this.subscriptionService.postStripeOrderCustomPayment(stripeToken, this.finalPrice, 'usd',
          "", this.currentUser.firstName+" "+ this.currentUser.lastName,
          this.address, this.city, this.state, this.country, this.postcode,
          this.finalPrice, this.addUserCount, this.isCustomPlan, this.checkoutToken).subscribe((data) => {
            localStorage.removeItem('loginPaymentDetails');
        });
      }
    });

    strikeCheckout.open({
      name: 'Crafttor',
      description: 'Stripe Payment Gateway',
      image: 'https://crafttor.com/crafttor.jpg',
      currency: 'usd',
      amount: this.finalPrice * 100
    });
  }

stripePaymentGateway() {
  if(!window.document.getElementById('stripe-script')) {
    const scr = window.document.createElement("script");
    scr.id = "stripe-script";
    scr.type = "text/javascript";
    scr.src = "https://checkout.stripe.com/checkout.js";

    scr.onload = () => {
      this.strikeCheckout = (<any>window).StripeCheckout.configure({
        key: environment.STRIPE_LIVE_KEY,
        locale: 'auto',
        token: function (token: any) {
        console.log(token)
        alert('Payment via stripe successfull!');
        }
      });
    }
    window.document.body.appendChild(scr);
    }
  }

  createRzpayOrder() {
    this.userRazorPayName = this.currentUser.firstName+" "+ this.currentUser.lastName;
    this.subscriptionService.getEnterpriseCustomPlanRazorOrderId(this.userRazorPayName, this.finalPrice,
      'usd', this.isCustomPlan, this.addUserCount, this.couponcode, this.checkoutToken).subscribe((data: any) => {
      this.orderId = data.razorpay_order_id;
      this.totalRazorAmount = data.razorpay_amount;
      this.razorPayKey = data.razorpay_merchant_key;
      this.payWithRazor(this.orderId, this.razorPayKey, this.totalRazorAmount,
        this.userRazorPayName,this.finalPrice, this.addUserCount);
    },(error: any) => {
      if(error.status == 400){
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  payWithRazor(totalVal: any, key: any, totalAmount: any, userName: any,
    totalValue: any, totalSeats: any) {
    localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: totalAmount}));
    const options: any = {
      key: key,
      amount: totalAmount*100,
      currency: 'USD',
      name: 'Crafttor', // company name or product name
      description: '',  // product description
      image: 'https://crafttor.com/crafttor.jpg', // company logo or product image
      order_id: totalVal, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#0c238a'
      }
    };
    options.handler = ((response, error) => {
      options.response = response;
      this.showTopRightLoader = true;
      this.subscriptionService.payEnterpriseCustomPlanRazorAmountOrderId(response.razorpay_payment_id,
        response.razorpay_order_id,response.razorpay_signature, userName,
        totalValue, totalSeats, this.isCustomPlan, this.couponcode, this.checkoutToken).subscribe((data: any) => {
          this.showTopRightLoader = false;
          // this.showLeaveLoader = false;
          // this.tellUsMoreSection = false;
          // this.signUpFormFilled = false;
          // this.showLoginPage = false;
          // this.showNotPageExist = false;
          // this.tellUsMoreSection = false;
          // this.createWorkspaceSection = false;
          // this.socialLoginSection = false;
          // this.paymentSuccessSection = true;
          // this.customCheckoutSection = false;
          this.router.navigate(['/dam/payment-success']);
      },(error: any) => {
        if(error.status == 400){
          this.showLeaveLoader = false;
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = false;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = true;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.showLeaveLoader = false;
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = false;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = true;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    // this.hideSuccesfullFunctionMsg();
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 5000);
  }

  openLoginModal(){
    if(this.currentUser){
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = false;
      this.paymentSuccessSection = false;
      this.customCheckoutSection = true;
    }else{
      this.customCheckoutSection = false;
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.paymentSuccessSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = true;
    }
  }

  signInWithGoogle(): void {
    if(this.currentUser){
      this.logOut();
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
    }else{
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
    }
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/login']);
  }

  loginToServer(user: any = null, photoUrl: string, workspace_token: string) {
    this.showGoogleLoginLoader = true;
    this.authenticationService.login(user.provider.toLowerCase(), user.id,
    user.authToken, user.email, user.firstName, user.lastName,
    photoUrl, this.lat, this.lng, workspace_token)
      .subscribe(
        (_data) => {
          this.getCustomPaymentData();
        },
        (error) => {
          if(error.status == 400){
            this.showGoogleLoginLoader = false;
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunctionErrorDelete();
          } else {
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunctionErrorDelete();
          }
      });
  }

  loginFunction(){
    this.submitted = true;
    this.loginErrorMsg = "";
    if (this.loginForm.valid) {
      this.showSendingSmall = true;
      this.showLeaveLoader = true;
        this.authenticationService.loginWithEmail(this.loginForm.value.email, this.loginForm.value.password, this.workspace_token).subscribe((data) => {
          this.showLeaveLoader = false;
          this.showSendingSmall = false;
          this.submitted = false;
          this.loginForm.reset();
          this.getCustomPaymentData();
        },
        (error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            errors[key].map((message) => {
              this.loginErrorMsg = message;
              this.submitted = false;
              this.showLeaveLoader = false;
              this.showSendingSmall = false;
            })
          })
       })
    }
  }

  signUpNextFuntion() {
    if (this.signUpForm.valid) {
      this.showSending = false;
      this.showSendingSmall = false;
      this.socialLoginSection = false;
      this.tellUsMoreSection = true;
      this.login = false;
      this.emailVerify = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.emailVerifySubmit = false;
      this.signUpFormFilled = true;
    }
  }

  signUpBackFuntion() {
    this.showSending = false;
    this.showSendingSmall = false;
    this.socialLoginSection = true;
    this.tellUsMoreSection = false;
    this.login = false;
    this.emailVerify = false;
    this.forgotpassword = false;
    this.forgotpasswordFields = false;
    this.enterOtp = false;
    this.resetPassword = false;
    this.signup = true;
    this.emailVerifySubmit = false;
  }

  signUpFormFunction(){
    this.submitt = true;
    if (this.signUpFormFilled) {
      this.showSendingSmall = true;
      this.showTellUsLoader = true;
      this.showTellUsMoreSectionError = false;
      this.authenticationService.registerWithEmail(this.signUpForm.value.fname,
        this.signUpForm.value.lname, this.emailIds,
        this.signUpForm.value.password, this.signUpForm.value.otp,
        this.enterNewDetails.value.organization, this.enterNewDetails.value.phoneNumber,
        this.selectRoleTitle, this.lat, this.lng, this.workspace_token)
        .subscribe(
          (_data) => {
            this.submitt = false;
            this.showLeaveLoader = false;
            this.showTellUsLoader = false;
            this.showSendingSmall = false;
            this.signUpForm.reset();
            this.enterNewDetails.reset();
            this.getCustomPaymentData();
        },
          (error) => {
            const errors = error.error || error.statusText;
            Object.keys(errors).map((key) => {
              errors[key].map((message) => {
                this.showTellUsMoreSectionError = true;
                this.tellUsMoreSectionErrorMsg = message;
                this.submitt = false;
                this.showTellUsLoader = false;
                this.showLeaveLoader = false;
                this.showSendingSmall = false;
                this.hideSuccesfullFunction();
              })
            })
         });
    }
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.sendSuccessfulMsg = false;
      this.showTellUsMoreSectionError = false;
      this.submitt = false;
      this.showTellUsLoader = false;
      this.showLeaveLoader = false;
      this.showSendingSmall = false;
    }, 3000);
  }

  resendOTP() {
    this.sendOTPFunction();
  }

  getOTP(){
    this.emailVerifySubmit = true;
    this.emailIds = this.emailVerifyForm.value.email
    if (this.emailVerifyForm.valid) {
      this.showSendingSmall = true;
      this.showLeaveLoader = true;
      this.sendOTPFunction();
    }
  }

  sendOTPFunction() {
    this.damService.getOTP(this.emailVerifyForm.value.email).subscribe((data: any) => {
      this.sendSuccessfulMsg = true;
      this.successfullMessage = "OTP sent Successfully!";
      this.hideSuccesfullFunction();
      this.showSendingSmall = false;
      this.showLeaveLoader = false;
      this.emailVerifyForm.reset()
      this.login = false;
      this.emailVerify = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = true;
      this.emailVerifySubmit = false;
    },
    (error) => {
      const errors = error.error || error.statusText;
      Object.keys(errors).map((key) => {
        errors[key].map((message) => {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = message;
          this.hideSuccesfullFunctionErrorDelete();
          this.emailVerifySubmit = false;
          this.showLeaveLoader = false;
          this.showSendingSmall = false;
        })
      })
    });
  }

  forgotPasswordFunction(){
    this.submittedForm = true;
    if (this.forgotPasswordForm.valid) {
      this.showSendingSmall = true;
      this.showLeaveLoader = true;
      this.damService.getResetPasswordOTP(this.forgotPasswordForm.value.email).subscribe((data: any) => {
        this.sendSuccessfulMsg = true;
        this.successfullMessage = "OTP sent Successfully!";
        this.hideSuccesfullFunction();
        this.showSendingSmall = false;
        this.showLeaveLoader = false;
        this.login = false;
        this.signup = false;
        this.forgotpassword = false;
        this.enterOtp = true;
        this.resetPassword = true;
        this.submittedForm = false;
      },
      (error) => {
        const errors = error.error || error.statusText;
        Object.keys(errors).map((key) => {
          errors[key].map((message) => {
            this.forgotPasswordErrorMsg = message;
            this.submittedForm = false;
            this.showLeaveLoader = false;
            this.showSendingSmall = false;
          })
        })
      });
    }
  }

  resetPasswordFunction(){
    this.passwordSubmit = true;
      if (this.enterOtpForm.valid) {
        this.showSendingSmall = true;
        this.showLeaveLoader = true;
        this.damService.resetPassword(this.forgotPasswordForm.value.email, this.enterOtpForm.value.otp,
          this.enterOtpForm.value.password, this.enterOtpForm.value.repassword).subscribe((data: any) => {
            this.sendSuccessfulMsg = true;
            this.successfullMessage = "Password reset Successfully!";
            this.hideSuccesfullFunction();
            this.showSendingSmall = false;
            this.showLeaveLoader = false;
            this.passwordSubmit = false;
            this.enterOtpForm.reset()
            this.forgotPasswordForm.reset()
            this.login = true;
            this.signup = false;
            this.forgotpassword = false;
            this.enterOtp = false;
            this.resetPassword = false;
          },
          (error) => {
            const errors = error.error || error.statusText;
            Object.keys(errors).map((key) => {
              errors[key].map((message) => {
                this.sendSuccessfulErrorMsg = true;
                this.sendSuccessfulErrorMessage = message;
                this.hideSuccesfullFunctionErrorDelete();
                this.passwordSubmit = false;
                this.showLeaveLoader = false;
                this.showSendingSmall = false;
              })
            })
        });
      }
    }

    showLoginScreen() {
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.emailVerify = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.login = true;
    }

    showEmailVerifyScreen() {
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.login = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.emailVerify = true;
    }

    showSignUpScreen() {
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.login = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.emailVerify = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.signup = true;
    }

    forgotScreen(){
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.loginForm.reset();
      this.login = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.emailVerify = false;
      this.forgotpasswordFields = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.forgotpassword = true;
    }

    showResetPasswordScreen() {
      this.showLeaveLoader = false;
      this.login = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.emailVerify = false;
      this.signup = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.resetPassword = true;
    }

    selectedRoleTitle(event: any) {
      this.selectRoleTitle = event.target.value;
    }

    listWorkspace(){
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        this.showSending = false;
        if(data.length > 0){
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = true;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = false;
        }else{
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = false;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = true;
        }
      });
    }

    createWorkspace(workspaceName: any){
      if(this.creatwWorkspace.valid) {
        this.showLeaveLoader = true;
        this.isShowCreateWorkspaceError = false;
        this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
          this.showLeaveLoader = false;
          this.tellUsMoreSection = false;
          this.signUpFormFilled = false;
          this.showLoginPage = false;
          this.showNotPageExist = false;
          this.tellUsMoreSection = false;
          this.createWorkspaceSection = false;
          this.socialLoginSection = false;
          this.paymentSuccessSection = false;
          this.customCheckoutSection = true;
        },
        (error) => {
          if(error.status == 403){
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true;
            this.createWorkspaceErrorMessage = error.error.Message;
          } else {
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true;
            this.createWorkspaceErrorMessage = error.error.Message;
          }
       });
      }
    }

    backToPricing() {
      this.showLeaveLoader = false;
      this.tellUsMoreSection = false;
      this.signUpFormFilled = false;
      this.showLoginPage = false;
      this.showNotPageExist = false;
      this.tellUsMoreSection = false;
      this.createWorkspaceSection = false;
      this.socialLoginSection = false;
      this.paymentSuccessSection = false;
      this.customCheckoutSection = true;
    }

    switchToWorkspace() {
      window.scrollTo(0, 0);
      if (this.currentUser) {
        this.router.navigate(['/dam']);
      }
    }
}
